import React from "react";
import { Widget, Action, mk_widget } from "widgets-for-react";

import { CookieState } from "../../public_site.main.mod";
import { t } from "i18next";
import { setCookie, CookieStatus } from "../../cms/blocks/cookiebar.utils.mod";
import { gtmPush } from "../../../helpers";

export const cookiebar: (
  _: CookieState
) => Widget<Action<CookieState>> = props =>
  mk_widget({
    run: o =>
      props.cookiebar == "open" && (
        <>
          <div className={`cookiebar cookiebar--open container container--s grid--block`}>
            <div className="cookiebar__inner">
              <header className="cookiebar__header">
                <h3 className="cookiebar__title">{t("cookiebar.title")}</h3>
                <div className="cookiebar__text text--styled">
                <p>{t("cookiebar.description")}</p>
              </div>
              </header>

              <div className="cookiebar__content">
                <ul className="cookiebar__options">
                  <CookieOption
                    name="complete"
                    click={() => {
                      o(s => ({ ...s, selectedCookie: "complete" }));
                    }}
                    currentCookie={props.selectedCookie}
                  />
                  <CookieOption
                    name="limited"
                    click={() => {
                      o(s => ({ ...s, selectedCookie: "limited" }));
                    }}
                    currentCookie={props.selectedCookie}
                  />
                  <CookieOption
                    name="functional"
                    click={() => {
                      o(s => ({ ...s, selectedCookie: "functional" }));
                    }}
                    currentCookie={props.selectedCookie}
                  />
                </ul>
              </div>

              <footer className="cookiebar__actions">
                <button
                  disabled={props.selectedCookie == 'undecided'}
                  className="btn btn--primary"
                  onClick={() => {
                    gtmPush({ category: 'Cookies', action: props.selectedCookie })

                    setCookie("cookies", props.selectedCookie, 365);
                    o(s => ({ ...s, cookiebar: "closed" }));
                    setTimeout(() => { window.location.reload() }, 50)
                  }}
                >
                  {t("cookiebar.accept")}
                </button>
                {/* <a className="btn btn--secondary" href="#">
                  {t("cookiebar.statement")}
                </a> */}
              </footer>
            </div>
          </div>
          <div className="cookiebar__overlay" />
        </>
      )
  });

const CookieOption = (props: {
  name: CookieStatus;
  click: () => void;
  currentCookie: CookieStatus;
}) => {
  return (
    <li className="cookiebar__item">
      <button onClick={props.click} className="cookiebar__option">
        <div className="cookiebar__option-inner">
          <span className={`cookiebar__option-label${
              props.name == props.currentCookie ? " active" : ""
            }`}>
            {t(`cookiebar.${props.name}.title`)}
          </span>
          <p className="cookiebar__option-description">
            {t(`cookiebar.${props.name}.description`)}
          </p>
        </div>
      </button>
    </li>
  );
};



// WEBPACK FOOTER //
// ./Client/components/public_site/templates/cookiebar.mod.tsx